import React from "react";
import { ROOM_COLORS, ROOM_STROKES, ROOM_TEMPLATES } from "../../constants";
import { w2pt, izoom } from "../../utils/coords";

export default function FaceLayer({ st, selFaceId, onSelect, zoom, selManyFaces }) {
  const s = izoom(zoom);
  const roomsLayer  = (st.layers || {}).rooms;
  const wallsLayer  = (st.layers || {}).walls;
  if (roomsLayer?.visible === false) return null;

  return (
    <g>
      {Object.values(st.faces).map(f => {
        const pts = f.loop
          .map(hid => { const he = st.halfEdges[hid]; return he ? w2pt(st.nodes[he.originId]) : null; })
          .filter(Boolean);
        if (pts.length < 3) return null;

        const isSel = f.id === selFaceId;
        const isMultiSel = (selManyFaces || []).includes(f.id);
        const rd     = (st.rooms || {})[f.id];
        const rt     = rd?.type || "ROOM";
        const bg     = ROOM_COLORS[rt]  || "#1a2030";
        const stroke = ROOM_STROKES[rt] || "#4ade80";
        const tmpl   = ROOM_TEMPLATES[rt] || ROOM_TEMPLATES.ROOM;
        const cx = f.centroid ? w2pt(f.centroid).x : 0;
        const cy = f.centroid ? w2pt(f.centroid).y : 0;

        return (
          <g key={f.id} onClick={e => { e.stopPropagation(); onSelect(f.id); }} style={{ cursor: "pointer" }}>
            <polygon
              points={pts.map(p => `${p.x},${p.y}`).join(" ")}
              fill={isMultiSel ? "#3b82f6" : bg} fillOpacity={isSel ? 0.7 : isMultiSel ? 0.25 : 0.4}
              stroke={isSel ? "#e8a838" : stroke}
              strokeWidth={isSel ? s * 1.5 : isMultiSel ? s * 0.6 : s * 0.3}
            />
            {f.centroid && (
              <g style={{ pointerEvents: "none" }}>
                <text x={cx} y={cy - s * 10} textAnchor="middle" fontSize={s * 7.5} fontWeight={600}
                  fill={isSel ? "#e8a838" : stroke} fontFamily="'JetBrains Mono',monospace">
                  {tmpl.icon} {rd?.name || tmpl.label}
                </text>
                <text x={cx} y={cy + s * 4} textAnchor="middle" fontSize={s * 7.5}
                  fill={stroke + "cc"} fontFamily="monospace">
                  {(f.area / 1e6).toFixed(1)} m²
                </text>
              </g>
            )}
          </g>
        );
      })}
    </g>
  );
}
